(function ($, Drupal) {

  'use strict';

  Drupal.geolocation = Drupal.geolocation || {};
  Drupal.geolocation.mapCenter = Drupal.geolocation.mapCenter || {};

  /**
   * @param centerOption.settings.reset_zoom {Boolean}
   */
  Drupal.geolocation.patriaSettings = {
      styleSettings: [
          {
              "featureType": "administrative",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": "-100"
                  }
              ]
          },
          {
              "featureType": "administrative.province",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "lightness": 65
                  },
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "lightness": "50"
                  },
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": "-100"
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "road.arterial",
              "elementType": "all",
              "stylers": [
                  {
                      "lightness": "30"
                  }
              ]
          },
          {
              "featureType": "road.local",
              "elementType": "all",
              "stylers": [
                  {
                      "lightness": "40"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                  {
                      "hue": "#787877"
                  },
                  {
                      "lightness": -20
                  },
                  {
                      "saturation": -97
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "labels",
              "stylers": [
                  {
                      "lightness": -25
                  },
                  {
                      "saturation": -100
                  }
              ]
          }
      ]
  };

  Drupal.geolocation.mapCenter.move_center = function(map, centerOption) {
    //var center = map.getCenter();
    //console.log(center);
    if(Drupal.geolocation.maps == undefined) {
      setTimeout(function(){
        Drupal.geolocation.mapCenter.discover_map();
      }, 1000);
    }
    else {
      var map = Drupal.geolocation.maps[0],
          center = map.getCenter(),
          zoom = map.googleMap.getZoom();
      if(map['id'] == 'what-do-we-do-header-unit-map-all') {
        console.log(map);
        console.log(zoom);
        map.mapCenter = {};
        center.lng = center.lng - (Math.ceil(100/zoom));
        map.lng = center.lng;
        map.lat = center.lat;
        map.setCenter(center);
        map.setZoom(zoom - 2);
        console.log(center);
      }
    }

    return false;
  }

  Drupal.geolocation.mapCenter.discover_map = function() {
    console.log('Searching for maps');
    Drupal.geolocation.mapCenter.move_center();
    return false;
  }

  Drupal.geolocation.mapCenter.move_center();

})(jQuery, Drupal);
